import React from 'react';
import { ShelfIcon } from './icons';
import { logo } from '../../theme/tokens';

/** Shelf logo mark: the white logo on the official navy gradient (same as the app icon). */
export default function BrandMark({ size = 32 }) {
    return (
        <span
            className="flex shrink-0 items-center justify-center"
            style={{ width: size, height: size, borderRadius: Math.round(size * 0.25), background: logo.gradient }}>
            <ShelfIcon style={{ width: Math.round(size * 0.55), filter: 'brightness(0) invert(1)' }} />
        </span>
    );
}
